var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoldCircleCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#F1A934",
    fillOpacity: 0.15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_98_11451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 12.7905V12.4267C22 12.0616 21.9041 11.703 21.7219 11.3869C21.5398 11.0707 21.2777 10.8082 20.9621 10.6257L16.0379 7.77858C15.7224 7.59608 15.3644 7.5 15 7.5C14.6356 7.5 14.2776 7.59608 13.9621 7.77858L9.03792 10.6265C8.72232 10.809 8.46025 11.0715 8.27806 11.3877C8.09587 11.7038 7.99996 12.0624 8 12.4275V12.9158L8.66142 13.2392V12.6377C8.66138 12.325 8.74357 12.0177 8.89971 11.7469C9.05586 11.476 9.28046 11.2511 9.55092 11.0949L13.9312 8.56171V9.77968L9.71569 12.2187V17.9161L13.9312 20.3541V21.5721L9.55092 19.0395C9.28044 18.8831 9.05583 18.6581 8.89968 18.3872C8.74354 18.1163 8.66136 17.8089 8.66142 17.4961V14.1047L8 13.7813V17.7061C7.99996 18.0711 8.09587 18.4298 8.27806 18.7459C8.46025 19.062 8.72232 19.3245 9.03792 19.5071L13.9566 22.3513C14.057 22.4093 14.1621 22.4589 14.2706 22.4995V8.36495L14.5529 8.20172C14.6921 8.12112 14.8501 8.07863 15.0109 8.07852H15.014C15.1886 8.07865 15.3597 8.1286 15.507 8.22251L15.7291 8.36495V22.5C15.838 22.4598 15.9432 22.4103 16.0436 22.3521L20.9618 19.5079C21.2774 19.3253 21.5395 19.0628 21.7217 18.7466C21.9039 18.4305 21.9998 18.0719 21.9997 17.7069V13.6592L21.3383 13.9898V17.495C21.3384 17.8078 21.2563 18.1151 21.1002 18.386C20.9442 18.6569 20.7197 18.8819 20.4493 19.0384L16.0691 21.5716V20.3541L20.284 17.9151V12.2187L16.0691 9.7802V8.56171L20.4491 11.0949C20.7194 11.2512 20.9439 11.4762 21.0999 11.747C21.256 12.0178 21.3381 12.325 21.3381 12.6377V13.1209L22 12.7905ZM13.9302 16.2176L10.3947 14.1101V12.6125L13.9302 10.568V16.2176ZM17.7468 14.918L18.5396 15.3905L19.6034 16.0247V17.521L16.0686 19.5656V13.9168L17.7468 14.918Z",
    fill: "url(#paint0_linear_98_11451)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_98_11451",
    x1: 15,
    y1: 6.87407,
    x2: 15,
    y2: 23.1077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B16D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F1AA36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FCD74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F1AA36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E38C05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FCD74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F1AA36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B16D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1AA36"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_98_11451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 15,
    fill: "white",
    transform: "translate(8 7.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldCircleCoin);
export default __webpack_public_path__ + "static/media/goldCircleCoin.014ef2ce97f5dd4cddec268e1c3723c5.svg";
export { ForwardRef as ReactComponent };